import Vue, { CreateElement } from '@src/vue'
import { Component } from 'vue-property-decorator'

import { CreateNote } from '@src/routes/members/components/notes/create'
import { NoteList } from '@src/routes/members/components/notes/list'
import { DatePicker } from '@src/elements/input/date-picker'
import { NoteFilters } from '@src/state/store'
import { formatDate, track } from '@src/util/functions'

import './notes.sass'
import { Input } from '@src/elements/input/input'

@Component({
  computed: {
    filters () {
      return this.$store.state.memberNoteFilters
    }
  }
})
export class MemberNotes extends Vue {

  private filters: NoteFilters

  constructor () {
    super()
    track('/members/notes')
  }

  updated () {
    document.title = `${this.$root.$t('PIXFORMANCE_PLATFORM')} - ${this.$root.$t('MEMBERS')} - ${this.$root.$t('PAGE.MEMBERS.DETAIL.TABS.NOTES')}`
  }

  filterByStartDate (value: string) {
    this.$store.dispatch('filterMemberNotes', { startDate: value })
  }

  filterByEndDate (value: string) {
    this.$store.dispatch('filterMemberNotes', { endDate: value })
  }

  filterNotes (value: string) {
    this.$store.dispatch('filterMemberNotes', { word: value })
  }

  render (h: CreateElement) {

    return <div class='member-notes-wrapper scroll-content'>
      <div class='filters-row row'>
        <Input ref='name' class='search' search={true} valueChanged={this.filterNotes} placeholder={this.$t('PAGE.MEMBERS.NOTES.SEARCH_PLACEHOLDER')}
               value={this.filters.word} />
        <DatePicker type='date' label={this.$t('START_DATE')} ref='startDate' value={this.filters.startDate} change={this.filterByStartDate}
                    allowFutureDate={false}
                    firstAvailableDate={this.filters.endDate ? formatDate(this.filters.endDate,'DD/MM/YYYY','MM/DD/YYYY') : new Date() }
        />
        <DatePicker type='date' label={this.$t('END_DATE')} ref='endDate' value={this.filters.endDate} change={this.filterByEndDate}
                    allowPastDate={!this.filters.startDate} allowFutureDate={!this.filters.startDate}
                    firstAvailableDate={this.filters.startDate ? formatDate(this.filters.startDate, 'DD/MM/YYYY', 'MM/DD/YYYY') : new Date()}/>

        <CreateNote />
      </div>

      <NoteList />
    </div>
  }
}
